window.$ = jQuery.noConflict(true);

import { toggleNavbarClassOnScroll, multiLevelDropdown } from './lib/navbar';
import { addIntersectionObservers } from './lib/animation-observer';




document.addEventListener('DOMContentLoaded', (e) => {
	/**
	 * Toggles class on navbar to update padding, background
	 * color, and logo stroke color.
	 */
	toggleNavbarClassOnScroll();
	multiLevelDropdown();

	/**
	 * Watches #main > * for intersection with viewport and
	 * adds a support class which we're using to trigger
	 * our css based animations.
	 */
	addIntersectionObservers();
});
